<div
  class="rent-to-watch-container horizontal-center back-btn"
  (click)="disabled($event)"
  (keydown)="handleKeydown($event)"
  (mousedown)="disabled($event)"
  (mouseup)="disabled($event)"
>
  <div class="rent-to-watch-modal">
    <h2 [style]="'fontSize.36' | translate">
      {{ 'rent_to_watch_title' | translate }}
    </h2>
    <p
      [innerHTML]="'rent_to_watch_desc' | translate"
      [style]="'fontSize.28' | translate"
    ></p>
    <div
      class="rent-to-watch-actions horizontal-as horizontal-focusable-container generic-dialog"
    >
      <app-icon-button
        [label]="'rent_now_title' | translate"
        [mode]="'subscribe'"
        class="rent-now-button"
        [isUppercase]="false"
        (clicked)="rentNowAction()"
      ></app-icon-button>
      <app-icon-button
        [label]="'global.cancel' | translate"
        (clicked)="cancelAction()"
      ></app-icon-button>
    </div>
  </div>
</div>
